import { resolvePath } from '@/utils/Path';

export default [
  {
    name: 'posterBackgroundTexture',
    type: 'texture',
    path: resolvePath(require("@/assets/img/textures/poster.jpg"))
  },
  {
    name: 'toileTexture',
    type: 'texture',
    path: resolvePath(require("@/assets/img/textures/toile.jpg"))
  },
  {
    name : 'textAlphaTexture',
    type : 'texture',
    path : resolvePath(require("@/assets/img/textures/textAlpha.jpg"))
  },
  {
    name: 'nameFont',
    type: 'font',
    path : resolvePath(require("@/assets/font/Kings_Caslon_Bold.json"))
  },
];